import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useAppConfigContext } from '@/context/AppConfig';
import { unclaimedMoneySearch } from '@/unclaimedMoney/index';

interface SearchQueryTypes {
  first_name: string;
  last_name: string;
  state: string;
}

export const useUnclaimedMoneySearch = (multiStateSearch: boolean) => {
  const [searchParams, setSearchParams] = useState('');
  const {
    routingUtils: { navigate },
    logError,
  } = useAppConfigContext();

  const handleReportSearch = async ({
    first_name,
    last_name,
    state,
  }: SearchQueryTypes) => {
    setSearchParams(
      `first_name=${first_name}&last_name=${last_name}&state=${state}`
    );

    return await unclaimedMoneySearch({
      first_name,
      last_name,
      state,
      multi_state_search: multiStateSearch,
    });
  };

  const useUnclaimedMoneyMutation = useMutation({
    mutationFn: handleReportSearch,
    onSuccess: (data) => {
      if (!multiStateSearch) {
        if (window.location.pathname.includes('report')) {
          navigate(
            `/report/unclaimed-money?${searchParams}&permalink=${data.report.permalink}`
          );
          window.location.reload();
        } else {
          navigate(
            `/report/unclaimed-money?${searchParams}&permalink=${data.report.permalink}`
          );
        }
      }
      return data.report.permalink;
    },
    onError: (error: Error) => {
      logError('Unclaimed Money Multi State Search', error as Error);
    },
  });

  return useUnclaimedMoneyMutation;
};
